export default __webpack_public_path__ + "static/eraf_lv-b7bbd7caebcb69df1158e84b72df3a1a.svg";